// import packags and folders

import Ss1 from './Bio'
import Header from '../../../headfoot/Header'

export default function ClassNotes() {
  return (
    <div>
      <Header />
      <div className="pt-20">
        <Ss1 />
      </div>
    </div>
  )
}
